<div class="mainInfo">
  <h1>{{ title }}</h1>
  <p>{{ subTitle }}</p>
</div>

<div class="msgBlock pt-30">
  <div class="msgBlock__wrapper">
    <div class="msgBlock__content">
      <div class="top bigBottomPad" *ngIf="otp">
        <div class="info">
          <div class="codeNumbers">
            <div class="codeNumbers__content">
              <div class="codeNumbers__item">
                <div class="subtitle mb-5"><h2>Pin de seguridad</h2></div>
                <div class="codeNumbers__input"><span>{{ otp }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom inverted lightBlue">
        <div class="bottom__image">
          <div class="image">
            <img src="assets/images/krediya-app.png" alt="Three phones displaying the Luki app on their screens">
          </div>
        </div>
        <div class="bottom__text">
          <div class="text">
            <p>Si aún no tienes instalada la aplicación, puedes hacerlo presionando <strong>"Descargar"</strong>.</p>
            <button pButton pRipple label="Descargar" icon="pi pi-download" iconPos="right" class="p-button-secondary p-button-raised p-button-rounded w-full n-border small" (click)="downLoadApp()"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="pt-30">
  <div class="footer__content">
    <app-phone-app-footer-button-shared [state]="appState" (continueClick)="onContinue()"></app-phone-app-footer-button-shared>
  </div>
</footer>

<app-phone-app-confirmation-modal-shared [visible]="visibleModal" (continueClick)="onContinue()"></app-phone-app-confirmation-modal-shared>
